import { renderSavedCopyOffer, SAVED_COPY_MARK } from 'BomdisoftComponents/pwa/register-service-worker/render';
import { delegateTooltips } from 'BomdisoftComponents/tooltip/delegate';
import type { SupportedLanguage } from '@bomdisoft/translations';

export type ServiceWorkerOptions = { isProduction: boolean; language: SupportedLanguage; swUrl?: string };

export const registerServiceWorker = (view: Window & typeof globalThis, { isProduction, language, swUrl = '/sw.js' }: ServiceWorkerOptions) => {
  if (isProduction && 'serviceWorker' in view.navigator) view.navigator.serviceWorker.register(swUrl);
  const { document } = view;
  if (document.querySelector(`meta[name="${SAVED_COPY_MARK}"]`) === null) return () => {};
  delegateTooltips(document);
  let offer: Element | null = null;

  const withdraw = () => {
    offer?.remove();
    offer = null;
  };

  const handleClick = (event: Event) => {
    const target = event.target instanceof view.Element ? event.target : null;
    if (target?.closest('[data-testid="snackbar-action"]')) {
      withdraw();
      view.location.reload();
      return;
    }
    if (target?.closest('[data-testid="snackbar-close"]')) withdraw();
  };

  const handleOnline = () => {
    if (offer !== null) return;
    const template = document.createElement('template');
    template.innerHTML = renderSavedCopyOffer({ closeTooltipId: 'saved-copy-offer-close-tooltip', language }).value;
    offer = template.content.firstElementChild;
    if (offer === null) return;
    offer.addEventListener('click', handleClick);
    document.body.append(offer);
  };

  view.addEventListener('online', handleOnline);
  return () => {
    view.removeEventListener('online', handleOnline);
    withdraw();
  };
};
